inputs-complex-checkbox-check-todo
  div(class="form-group row {error: opts.errors}")
    label.col-md-4.col-form-label
      | {opts.label}
    .col-md-8
      .row
        .col-md-6(each="{item, namespace in opts.items}")
          span
            .checkbox-fade.fade-in-primary
              input(type="hidden" value="0" name="{ item.name }")
              label
                input(type="checkbox" value="{ item.value }" name="{ item.name }" onClick="{ this.onChange }" data-id="{namespace}" checked="{item.checked}")
                input(if="{ item.value == '1' }" type="checkbox" value="1" name="{ item.name }" onClick="{ this.onChange }" data-id="{namespace}" checked="checked")
                input(if="{ item.value != '1' }" type="checkbox" value="1" name="{ item.name }" onClick="{ this.onChange }" data-id="{namespace}")
                span.cr
                  i.cr-icon.icofont.icofont-ui-check.txt-primary
                span { item.label }
        div.help-block(if="{ opts.errors }")
          ul(role="alert")
            li.text-danger.error(each="{message in opts.errors}") { message }
  script(type="typescript").
    this.mixin('inputs.checkbox-multiple');
